import { NavItemType } from '../types/menu';
import {
  Courthouse,
  DocumentUpload,
  UserSearch,
  Building,
  Calendar,
  Notification,
} from 'iconsax-react';

import i18n from '../i18n';
const icons = {
  upload: DocumentUpload,
  school: Courthouse,
  findStudent: UserSearch,
  onboarding: Building,
  calendar: Calendar,
  notifications: Notification,
};
const studentsMenu: NavItemType = {
  id: 'students',
  title: i18n.t('nav_section.school'),
  type: 'group',
  children: [
    {
      id: 'findStudent',
      title: i18n.t('sidebar.find_student'),
      type: 'item',
      url: '/search',
      icon: icons.findStudent,
    },
    {
      id: 'onboarding',
      title: i18n.t('sidebar.onboarding'),
      type: 'item',
      url: '/onboarding',
      icon: icons.onboarding,
    },
    {
      id: 'notifications',
      title: i18n.t('sidebar.notifications'),
      type: 'item',
      url: '/notifications',
      icon: icons.notifications,
    },
    {
      id: 'calendar',
      title: i18n.t('sidebar.calendar'),
      type: 'item',
      url: '/calendar',
      icon: icons.calendar,
    },
  ],
};
export default studentsMenu;
